module.exports = __webpack_public_path__ + "img/group-5.63c1a1f2.svg";